const callIdKey = 'callId'

// callId
export const getCallId = () => {
  return localStorage.getItem(callIdKey)
}

export const setCallId = value => {
  return localStorage.setItem(callIdKey, value)
}

export const removeCallId = () => {
  return localStorage.removeItem(callIdKey)
}
